// MapNavigationIcon
const MapNavigationIcon = ({ width = 16, height = 16, color = '#222223' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8414 3.79093C13.9187 3.5747 13.8551 3.33321 13.6814 3.18302C13.5077 3.03284 13.2596 3.00484 13.0568 3.11254L2.52067 8.70792C2.31169 8.8189 2.19581 9.04995 2.23184 9.28382C2.26787 9.51768 2.44792 9.70315 2.68061 9.74608L7.27399 10.5937L8.77623 15.0165C8.85233 15.2405 9.06185 15.3919 9.29847 15.3938C9.53508 15.3956 9.74698 15.2476 9.82661 15.0248L13.8414 3.79093Z"
        fill={color}
      />
    </svg>
  )
}

export default MapNavigationIcon
